import React, {useState} from 'react';
import './Retardos.css';
import api from '../../../services/api.js';
import swal from 'sweetalert';
import Loader from '../../Loader/Loader.js';
import { height, width } from '@fortawesome/free-solid-svg-icons/fa0';

const RetardosComponent = () => {
    const formato = new Intl.DateTimeFormat('en-CA', {
        timeZone: 'America/Mazatlan',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
    const today = formato.format(new Date());
    const [alumnos, setAlumnos] = useState([]);
    const [date, setDate] = useState(today);
    const [endDate, setEndDate] = useState(today);
    const [turno, setTutno] = useState("");
    const [grado, setGrado] = useState("");
    const [grupo, setGrupo] = useState(null);
    const [numFaltas, setNumFaltas] = useState(3);

    const [mensaje, setMensaje] = useState('');
    const [showMessage, setShowMessage] = useState(false);
    const [alumnosSeleccionados, setAlumnosSeleccionados] = useState([]);

    const buttonDisable = {
        cursor: "not-allowed",
        opacity: "0.5",
        pointerEvents: "none",
    }

    const buscarAlumnos = async () => {
        try {
            const response = await api.getRetardosAlumnos({endDate, turno, grado, date, grupo, numFaltas});
            setAlumnos(response.data.data);
            if (response.data.data.length == 0) {
                swal("Error", "No se encontraron retardos en esa fecha.", "error");
            }
        } catch (error) {
            swal("Error", "Intente de nuevo más tarde.", "error");
            return;
        }
    }

    const enviarMensajes = async () => {
        try {
            await api.postMessagePrefectos({alumnosSeleccionados, mensaje});
            setShowMessage(false);
            swal("¡Éxito!", "Los mensajes se enviaron correctamente.", "success");
        } catch (error) {
            swal("Error", "Intente de nuevo más tarde.", "error");
        }

    }

    const handleCheckboxChange = (alumno) => {
        setAlumnosSeleccionados(prevSeleccionados =>
          prevSeleccionados.includes(alumno)
            ? prevSeleccionados.filter(item => item !== alumno)
            : [...prevSeleccionados, alumno]
        );
    };

    return (
        <>
        <div className= "seccion-materias hover-seccion fade-in">
            <div className= "seccion-centro">
                <div className='container-filtros'>
                    <div className='filtros-input filtros-input-date'>
                        <label>Del día: </label>
                        <input type="date" value={date} onChange={ e => (setDate(e.target.value))}></input>
                        <label>Al día</label>
                        <input type="date" value={endDate} onChange={ e => (setEndDate(e.target.value))}></input>
                    </div>
                    <div className='filtros-input'>
                        <label>Turno</label>
                        <select name="Turno" onChange={e => (setTutno(e.target.value))}>
                            <option value="" defaultChecked>TODOS</option>
                            <option value="MATUTINO">MATUTINO</option>
                            <option value="VESPERTINO">VESPERTINO</option>
                        </select>
                    </div>
                    <div className='filtros-input'>
                        <label>Grado</label>
                        <select name="Grado" onChange={e => (setGrado(e.target.value))}>
                            <option value="" defaultChecked>TODOS</option>
                            <option value="PRIMERO">PRIMERO</option>
                            <option value="SEGUNDO">SEGUNDO</option>
                            <option value="TERCERO">TERCERO</option>
                        </select>
                    </div>
                    <div className='filtros-input'>
                        <label>Grupo</label>
                        <input type="number" onChange={ e => (setGrupo(e.target.value))}></input>
                        <label>Num. Retardos</label>
                        <input type="number" onChange={ e => (setNumFaltas(e.target.value))} value={numFaltas}></input>
                    </div>
                    <button onClick={buscarAlumnos}>BUSCAR</button>
                    <button onClick={e => setShowMessage(true)} style={alumnosSeleccionados.length > 0 ? {} : buttonDisable} id='button-actualizar'>NOTIFICAR</button>
                </div>
                <div className= "seccion-tabla-asistencias">
                    <div className= "hover-elemento">
                        {/* TABLA */}
                        <div className= "contenedor-tabla-asistencias">
                            <table className= "tabla-asistencias">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th><label>MATRICULA</label></th>
                                        <th><label>ALUMNO</label></th>
                                        <th><label>TURNO</label></th>
                                        <th><label>GRADO</label></th>
                                        <th><label>GRUPO</label></th>
                                        <th><label>RETARDOS</label></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { alumnos && alumnos.map( (alumno, i) => { 
                                        return (
                                        <tr key={ i }>
                                            <td><input type="checkbox" style={{width:'20px', height:'30px'}} onChange={() => handleCheckboxChange(alumno)}
                                                checked={alumnosSeleccionados.includes(alumno)}/></td>
                                            <td>{ alumno.MATRICULA }</td>
                                            <td>{ alumno.ALUMNO }</td>
                                            <td>{ alumno.TURNO }</td>
                                            <td>{ alumno.GRADO }</td>
                                            <td>{ alumno.GRUPO }</td>
                                            <td>{ alumno.CANTIDAD_RETARDOS }</td>
                                        </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        { showMessage ? <>
            <div className='overlay'></div>
            <div className='container-message'>
                <div className='titulo-message'>
                    <h3>ESCRIBE EL MENSAJE A ENVIAR</h3>
                    <label className='button-close-buscar-alumno' onClick={e => setShowMessage(false)}> X </label>
                </div>
                <div className='message'>
                    <textarea value={mensaje} onChange={e => setMensaje(e.target.value)}></textarea >
                </div>
                <div className='button-enviar-mensaje'>
                    <button onClick={enviarMensajes}>ENVIAR</button>
                </div>
            </div>
        </> : ''}
        </>
    );
};

export default RetardosComponent;